var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"600px","height":"400px"},attrs:{"id":"myChart"}})])
}]

export { render, staticRenderFns }